<div class="footer-content">
    <p class="mb-0">Sistema Milano Models</p>
    <span>
        <a href="https://dreamslab.cl" class="text-gray me-3">Dreamslab.cl</a>
    </span>
</div>